import { Controller } from '@hotwired/stimulus';

// Live character count for the review comment field (max enforced in HTML + model).
export default class extends Controller {
  static targets = ['input', 'counter'];
  static values = { max: Number, template: String };

  connect() {
    this.refresh();
  }

  refresh() {
    const count = this.inputTarget.value.length;
    this.counterTarget.textContent = this.templateValue
      .replace('__COUNT__', count)
      .replace('__MAX__', this.maxValue);
  }
}
